import { Link, NavLink } from "react-router-dom";

export const SectionLink = ({ url, nav, className, children, ...props }) =>
  url.startsWith("http") ? (
    <a href={url} className={className} {...props}>{children}</a>
  ) : nav ? (
    <NavLink to={url} className={({ isActive }) => `${className} ${isActive ? "!bg-[#F0EBE1] !text-stone-900 font-medium" : ""}`} {...props}>{children}</NavLink>
  ) : (
    <Link to={url} className={className} {...props}>{children}</Link>
  );
